// extracted by mini-css-extract-plugin
export default {"accordion":"FilterList_accordion__ukUEn"};